import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import 'vue-material-design-icons/styles.css';

Vue.config.productionTip = false

new Vue({
  axios,
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
